exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-14c65aee] {\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n}\n.card .progress[data-v-14c65aee] {\n  border-radius: 0;\n  height: 15px;\n}", ""]);

// exports
